import { StateType } from 'src/redux/reducers';

export const peopleFoldersSelector = ({ people: { folders } }: StateType) => folders;
export const peopleTagsSelector = ({ people: { tags } }: StateType) => tags;
export const peopleFiltersSelector = ({ people: { filters } }: StateType) => filters;
